import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { log } from './lib/logger';
import './styles/app.css';

window.addEventListener('unhandledrejection', (e: PromiseRejectionEvent) => log.error('unhandled_rejection', { reason: String(e.reason) }));
window.addEventListener('error', (e: ErrorEvent) => log.error('window_error', { message: e.message, source: e.filename, line: e.lineno }));

const rootEl: HTMLElement | null = document.getElementById('root');
if (!rootEl) throw new Error('index.html is missing <div id="root">.');
createRoot(rootEl).render(<StrictMode><App /></StrictMode>);
